import { render } from "./ZLoader.vue?vue&type=template&id=027d5915"
import script from "./ZLoader.vue?vue&type=script&lang=js"
export * from "./ZLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__